// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hLVEk","buttons":"styles_buttons__1ffF4"};